/*跨域地址*/
let dev = process.env.dev;
dev = dev + "/c";
const pay = process.env.pay;

export default {
  /**提交服务定价订单信息 */
  createOrder: {
    url: dev + "/sv/drm/order",
    method: "post",
  },
  /**订单支付 */
  payOrder: {
    url: pay + "/sv/wx/pay",
    method: "post",
  },
  /**支付成功匹配服务顾问 */
  matchAgent: {
    url: dev + "/sv/match/agent",
    method: "post",
  },
  /**获取服务记录列表接口 */
  getSvRecordList: {
    url: dev + "/sv/svRecordList",
    method: "get",
  },
  /**创建数据回流 */
  createDataFlow: {
    url: dev + "/data/flow",
    method: "post",
    config: {
      closeLoading: true,
      noRedirect: true,
    },
  },
  /**生成访问时长 */
  browDataFlow: {
    url: dev + "/data/flow/brow/time",
    method: "post",
    config: {
      closeLoading: true,
      noRedirect: true,
    },
  },
  /**drm点亮分享 */
  drmRight: {
    url: dev + "/sv/drm/light",
    method: "get",
  },
  /** 提交咨询需求 */
  svRemind: {
    url: dev + "/sv/remind",
    method: "post",
  },
  /** 判断是否下过单*/
  getOrderJudge: {
    url: dev + "/sv/pm/order/judge",
    method: "get",
  },
  /** 根据产品查询产品信息*/
  getPmProductInfo: {
    url: dev + "/sv/product/info",
    method: "get",
  },
  /** 预约支付成功后，查看是否用券成功 */
  updateCoupon: {
    url: dev + "/sv/update/discount/coupon",
    method: "post",
  },
  /** 查询活动收费券的状态 */
  getCouponStatus: {
    url: dev + "/sv/discount/coupon/status",
    method: "get",
  },
  /** 领取收费券 */
  discountCoupon: {
    url: dev + "/sv/bind/discount/coupon",
    method: "post",
  },

  /**托管付费订单提交 */
  createPmOrder: {
    url: dev + "/sv/pm/order",
    method: "post",
  },
  /** 获取代理分享托管付费页面配置信息*/
  getPmAgentInfo: {
    url: dev + "/agent/config",
    method: "get",
  },
  /**drm点亮分享 */
  drmBadgeList: {
    url: dev + "/agent/drm/badge/list",
    method: "get",
  },
  /**证书列表【新】 20140118 xuyq */
  badgeList: {
    url: dev + "/noauth/badge/list",
    method: "get",
  },
  /** 查询付费咨询客户是否有专属服务顾问 */
  haveAgent: {
    url: dev + "/sv/cust/have/agent",
    method: "get",
  },
  /**查询代理人证书*/
  getAgentCertificateInfo: {
    url: dev + "/noauth/agent/certificate/info",
    method: "get",
  },
  /**app订单支付 */
  payOrderByApp: {
    url: pay + "/sv/app/wx/pay",
    method: "post",
  },
};



// WEBPACK FOOTER //
// ./src/api/placeAgent.js